import { SCHEMA_V1 } from '../schema'
import type { Migration, MigrationContext } from './index'

/**
 * Version 1 — create every store and index defined by D-027.
 *
 * All fourteen stores are created now, including those whose entity is modelled
 * in a later checkpoint. Adding a store later means another migration and
 * another round of upgrade risk on a device holding the user's only copy of the
 * data; creating them up front costs nothing.
 */
export const migrationV1: Migration = {
  to: 1,
  describe: 'Create initial object stores and indexes',
  run({ database, transaction }: MigrationContext): void {
    for (const definition of SCHEMA_V1) {
      const store = database.objectStoreNames.contains(definition.name)
        ? transaction.objectStore(definition.name)
        : database.createObjectStore(definition.name, { keyPath: definition.keyPath })

      for (const index of definition.indexes) {
        if (store.indexNames.contains(index.name)) continue
        store.createIndex(
          index.name,
          Array.isArray(index.keyPath) ? [...index.keyPath] : (index.keyPath as string),
          index.unique === true ? { unique: true } : {},
        )
      }
    }
  },
}
